import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {ToastModule} from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { DragDropModule } from 'primeng/dragdrop';


/**
 * rutas
 */
import { AppRoutingModule } from 'src/app/app.routes';
/**
 * Servicios
 */
import { ProductsService } from './services/producto/products.service';
import {MessageService} from 'primeng/api'

 /**
  * Componentes
  */
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { FormulariosComponent } from './components/formularios/formularios.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ProductsComponent } from './components/products/products.component';
import { EditProductComponent } from './components/edit-product/edit-product.component';
import { MenuComponent } from './components/menu/menu.component';
import { CategoriaProductsComponent } from './modules/productos/categoria-productos/categoria-productos.component';


import { SidebarComponent } from './components/sidebar/sidebar.component';

import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidenavCellComponent } from './components/dashboard/sidenav-cell/sidenav-cell.component';
import { SidenavComponent } from './components/dashboard/sidenav/sidenav.component';

/* de tiritas.module */
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/components/slider/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ConfirmationService} from 'primeng/api';
import { utensiliosComponent } from './modules/utensilios/categoria-utensilios/utensilios.component';
import { CategoriaParametrosComponent } from './modules/parametros/categoria-parametros/categoria-parametros.component';

import { ControlCristalModule } from './modules/control/app.control.modules';
import { CategoriaControlComponent } from './modules/control/categoria-control/categoria.component';
import { tiritasComponent } from './modules/tiritas/categoria-tiritas/tiritas.component';
import { AnexoComponent } from './components/anexo/anexo.component';
import { ColumnManagerComponent } from './components/column-manager/column-manager.component';
import { FormManagerComponent } from './components/form-manager/form-manager.component';
// import { PesosCreateComponent } from './modules/pesos/create/pesos.component';
import { PesosComponent } from './modules/pesos/pesos.component';
import { ListPesosComponent } from './modules/pesos/list/list-pesos/list-pesos.component';
// import { UpdatePesosComponent } from './modules/pesos/update/updatePesos.component';
import { ImprimirSharedModule } from './components/imprimir/imprimir.module.share';
import { PesosGirsacComponent } from './modules/girsac/pesos.component';
import { ImprimirPesosSharedModule } from './components/imprimirPesos/imprimir-pesos.module.share';
import { ZumosCategoriaComponent } from './modules/zumos/zumos-categoria/zumos-categoria.component';
import { PesosCreateUpdateComponent } from './modules/pesos/create-update/pesosCreateUpdate.component';

import { EtiquetaCategoriaComponent } from './modules/etiquetas/etiquetas-categoria/etiquetas-categoria.component';
import { UsuarioCategoriaComponent } from './modules/usuarios/usuarios-categoria/usuarios-categoria.component';
import { VariedadesCategoriaComponent } from './modules/variedades/variedades-categoria/variedades-categoria.component';
import { VehiculosCategoriaComponent } from './modules/vehiculos/vehiculos-categoria/vehiculos-categoria.component';
import { PipeModule } from './pipes/pipe.module';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { CategoriaTestVidaComponent } from './modules/test-de-vida/categoria-test-de-vida/categoria-test-de-vida.component';
import { CategoriaConformidadComponent } from './modules/conformidad/categoria-conformidad/categoria-conformidad.component';
import { CategoriaTransporteComponent } from './modules/transporte/categoria-transporte/categoria-transporte.component';
import { ImprimirPesosPitufoMultipleSharedModule } from './components/imprimir-multilples/imprimir-pesos-pitufo/imprimir-pesos-pitufo-multiple.module.share';
import { PaisesCategoriaComponent } from './modules/paises/paises_categoria/paises-categoria.component';
import { CategoriaTransporteRutasComponent } from './modules/transporte-rutas/categoria-transporte/categoria-transporte.component';
import { CheckboxModule } from 'primeng/checkbox';
import {AccordionModule} from 'primeng/accordion';
import { BotonesActionModule } from './components/botones/botones.module';
import { SimpleTableModule } from './components/table/simple-table/simple-table.modules';

import {CardModule} from 'primeng/card';
import { UploadDocumentacionComponent } from './components/upload-documentacion/upload-documentacion.component';
import { FileUploadModule } from 'primeng/fileupload';
import {ButtonModule} from 'primeng/button';
import {SlideMenuModule} from 'primeng/slidemenu';
import { TipoResiduosCategoriaComponent } from './modules/tipo-residuos/tipo-residuos-categoria/tipo-residuos-categoria.component';

import { GraficaCategoriaComponent } from './modules/grafica/grafica-categoria/grafica-categoria.component';

import { ChartModule } from 'primeng/chart';
import { UbicacionCategoriaComponent } from './modules/SGAubicacion/ubicacion-categoria/ubicacion-categoria.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { CommonChartModule } from './components/common-chart/common-chart.module';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    FormulariosComponent,
    PageNotFoundComponent,
    ProductsComponent,
    EditProductComponent,
    SidebarComponent,
    DashboardComponent,
    LoginComponent,
    DashboardComponent,
    SidenavCellComponent,
    SidenavComponent,
    CategoriaProductsComponent,
    utensiliosComponent,
    CategoriaParametrosComponent,
    CategoriaControlComponent,
    tiritasComponent,
    AnexoComponent,
    ColumnManagerComponent,
    FormManagerComponent,
    PesosComponent,
    // PesosCreateComponent,
    ListPesosComponent,
    // UpdatePesosComponent,
    PesosGirsacComponent,
    PesosComponent,
    ZumosCategoriaComponent,
    EtiquetaCategoriaComponent,
    UsuarioCategoriaComponent,
    GraficaCategoriaComponent,
    VariedadesCategoriaComponent,
    VehiculosCategoriaComponent,
    DocumentosComponent,
    CategoriaTestVidaComponent,
    CategoriaConformidadComponent,
    CategoriaTransporteComponent,
    PaisesCategoriaComponent,
    CategoriaTransporteRutasComponent,
    UploadDocumentacionComponent,
    TipoResiduosCategoriaComponent,
    //ReplaceSemicolonPipe
    PesosCreateUpdateComponent,
    UbicacionCategoriaComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ImprimirPesosSharedModule,
    TieredMenuModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastModule,
    MessagesModule,
    TableModule,
    DragDropModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    SliderModule,
    CalendarModule,
    RadioButtonModule,
    InputSwitchModule,
    ConfirmDialogModule,
    ControlCristalModule,
    FormsModule,
    ImprimirSharedModule,
    PipeModule,
    CheckboxModule,
    AccordionModule,
    ImprimirPesosPitufoMultipleSharedModule,
    SimpleTableModule,
    BotonesActionModule,
    FileUploadModule,
    ButtonModule,
    CardModule,
    SlideMenuModule,
    ChartModule,
    CommonChartModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    ProductsService,
    MessageService,
    ConfirmationService
  ],
  bootstrap: [AppComponent],
  exports:[
    CategoriaTestVidaComponent,
  ]
})
export class AppModule { }
